<template>
  <div
    v-multiclick
    v-hammer:tap="onTap"
    class="like-container"
    @single-click="$emit('click')"
    @double-click="activate"
  >
    <div class="like-icon">
      <font-awesome-icon
        v-if="active"
        class="heart"
        icon="heart"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'Heart',
  data() {
    return {
      active: false,
    };
  },
  methods: {
    /** Just attaching hammer tap fixes double click like.
     * If this isn't done, double tap defaults to mobile browser zoom. */
    onTap() {
      console.debug('Heart tapped');
    },
    activate() {
      if (this.active) {
        return;
      }
      this.active = true;
      this.$emit('liked');
      setTimeout(() => {
        this.active = false;
      }, 1000);
    },
  },
};
</script>

<style lang="scss" scoped>
.like-icon {
    position: absolute;
    transform: translateY(-50%);
    color: white;
    font-size: 80px;
    min-height: 100%;
    min-width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.heart {
    transform: scale(0);
    opacity: 0;
    filter: drop-shadow(0 0 20px rgba(black, 0.2));
    animation-duration: 1000ms;
    animation-name: like-heart-animation;
    animation-timing-function: ease-in-out;
    pointer-events: none
}

@keyframes like-heart-animation {
    0%,
    to {
        opacity: 0;
        -webkit-transform: scale(0);
        transform: scale(0)
    }
    15% {
        opacity: .9;
        -webkit-transform: scale(1.2);
        transform: scale(1.2)
    }
    30% {
        -webkit-transform: scale(.95);
        transform: scale(.95)
    }
    45%,
    80% {
        opacity: .9;
        -webkit-transform: scale(1);
        transform: scale(1)
    }
}
</style>
